import React, {
  cloneElement,
  createElement,
  isValidElement,
  useContext,
} from 'react';

import { withStyles } from '@mui/styles';
import { Button as MuiButton } from '@mui/material';

import RefreshIcon from '@mui/icons-material/Cached';

import { TableContext } from './context.table';
import { ColumnCustomizer } from './column-customizer/column-customizer.table';

const styles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    marginBottom: 10,
    marginTop: 30,
  },
  buttonRoot: {
    minWidth: 'auto',
  },
  altFlex: {
    justifyContent: 'space-between',
    alignItems: 'flex-end',

    '& .MuiTextField-root + .MuiIconButton-root': {
      marginLeft: '.8rem',
    },

    '& .MuiTextField-root + .MuiButton-root, & * + .MuiButton-root': {
      marginLeft: '1.5rem',
    },

    '& .MuiIconButton-root + .MuiButton-root': {
      marginLeft: '.8rem',
    },

    '& .MuiButton-root + .MuiButton-root': {
      marginLeft: '1.5rem',
    },

    '& .MuiButton-root + .MuiIconButton-root': {
      marginLeft: '.8rem',
    },
  },
});

export const ActionBar = withStyles(styles)(
  ({ render, children, classes, ...props }: any) => {
    const { onRefresh, ...context } = useContext(TableContext);

    if (typeof render === 'function') {
      return (
        <div className={`action-bar ${classes.altFlex}`}>
          {render(props, context)}
        </div>
      );
    }

    return (
      <div className={`action-bar ${classes.altFlex}`}>
        {React.Children.map(children, (child) =>
          isValidElement(child)
            ? // @ts-expect-error TS(2698): Spread types may only be created from object types... Remove this comment to see the full error message
              cloneElement(child, { ...child.props, ...props })
            : createElement('div', { ...child.props, ...props }, child)
        )}
        <div>
          <ColumnCustomizer />
          <MuiButton
            className={classes.buttonRoot}
            variant="contained"
            size="small"
            color="secondary"
            onClick={onRefresh}
          >
            <RefreshIcon fontSize="small" />
          </MuiButton>
        </div>
      </div>
    );
  }
);

// @ts-expect-error TS(2339): Property 'displayName' does not exist on type 'JSX... Remove this comment to see the full error message
ActionBar.displayName = 'ActionBar';

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'JS... Remove this comment to see the full error message
ActionBar.defaultProps = {
  columns: [],
  data: [],
  total: 0,
};
